import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { OrganizationApi } from "../../../../../../../../../../services/Api/types";
import { selectPartner } from "../../../../../../../../../../services/partner/selectors";
import { isPosnetPartner } from "../../../../../../utils";
import CreatePartnerOrganizationModal from "../../../../components/CreatePartnerOrganizationModal";

const PartnerPreviewOrganizationsNewPage = () => {
	const history = useHistory();
	const partner = useSelector(selectPartner);
	const { t } = useTranslation("admin");
	const [showOrganizationModal, setShowOrganizationModal] = useState(false);
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(
			`${t("modules.organization.header.new.title")} | ${t("modules.partner.field.partner_panel.title")}`
		);
	}, []);

	useEffect(() => {
		if (isPosnetPartner(partner?.parent)) goBack();
	}, [partner]);

	const goBack = () => {
		history.push(`/partnership/${partner?.id}/organizations`);
	};

	const onHideModal = (data?: OrganizationApi) => {
		setShowOrganizationModal(false);
		if (data) {
			history.push(`/partnership/${partner?.id}/organizations/${data?.id}`);
		}
	};

	return (
		<>
			<Header title={t("modules.organization.header.new.title")} back={goBack} />
			<div className={"row"}>
				<div className={"col-md-4"}>
					<Card
						className={"card-hover h-100"}
						style={{ cursor: "pointer" }}
						onClick={() => setShowOrganizationModal(true)}
					>
						<Card.Body>
							<h5>{t("modules.organization.action.add_organization_v2.title")}</h5>
						</Card.Body>
					</Card>
				</div>
			</div>
			{showOrganizationModal && (
				<CreatePartnerOrganizationModal partnerId={Number(partner?.id)} onHide={onHideModal} />
			)}
		</>
	);
};
export default PartnerPreviewOrganizationsNewPage;
